export default __webpack_public_path__ + "static/media/Emojis15.d2f527fa.png";